<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

import axios from 'axios';

export default {
  name: 'App',

  data: () => ({
    //
  }),

  methods: {
    loginCheck() {
      if (!localStorage.getItem('token')) {
        this.$router.push('/login');
      } else {
        axios.get(process.env.VUE_APP_API_URL + '/api/admin/admin/me', {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        }).then((res) => {
          console.log(res.data);
        }).catch(() => {
          alert("로그인이 필요합니다.");
          this.$router.push('/login');
        });
      }
    },
    
  },

  computed: {
    config() {
      return {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      }
    }
  },
}
</script>

<style>

@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard-gov.min.css");

.v-container {
    font-family: "Pretendard GOV Variable", "Pretendard GOV", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important;    
    background-color: #ececec !important;
    width : 100% !important;
    max-width: 100% !important;
    height : 100% !important;
}

div {
    font-family: "Pretendard GOV Variable", "Pretendard GOV", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important;    
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}


</style>